import { CategoryQuestions } from '../types';

export const couplesConnectionQuestions: CategoryQuestions = {
  title: 'Personalize Your Couples Connection Session',
  questions: {
    preferredStyle: {
      label: 'What approach feels most supportive for your relationship right now?',
      type: 'radio',
      options: ['Gentle reconnection exercises', 'Communication enhancement', 'Trust and vulnerability building', 'Emotional healing together', 'Physical intimacy renewal', 'Partnership strengthening']
    },
    primaryGoal: {
      label: 'What would you most like to focus on in your couples session?',
      type: 'radio',
      options: ['Deepening emotional connection', 'Improving communication patterns', 'Rebuilding trust and safety', 'Healing relationship wounds', 'Enhancing physical intimacy', 'Strengthening partnership bond']
    },
    relationshipStage: {
      label: 'What best describes your current relationship stage?',
      type: 'radio',
      options: ['New couple building connection', 'Established relationship seeking renewal', 'Working through relationship challenges', 'Recovering from relationship difficulties', 'Long-term partnership maintenance', 'Preparing for relationship transition']
    },
    communicationStyle: {
      label: 'How do you and your partner typically communicate?',
      type: 'radio',
      options: ['Open and direct', 'Gentle and considerate', 'Need help expressing feelings', 'Sometimes defensive or guarded', 'Working on listening skills', 'Learning healthy conflict resolution']
    },
    intimacyFocus: {
      label: 'What aspect of intimacy would you like to strengthen?',
      type: 'radio',
      options: ['Emotional vulnerability and sharing', 'Physical touch and affection', 'Mental connection and understanding', 'Spiritual or values alignment', 'Playfulness and joy together', 'All aspects equally']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  groupTitle: 'Personalize Your Group Couples Session',
  groupQuestions: {
    preferredStyle: {
      label: 'What approach feels most supportive for your group?',
      type: 'radio',
      options: ['Gentle reconnection exercises', 'Communication enhancement', 'Trust and vulnerability building', 'Emotional healing together', 'Physical intimacy renewal', 'Partnership strengthening']
    },
    primaryGoal: {
      label: 'What would be most helpful for the group to focus on together?',
      type: 'radio',
      options: ['Building healthy communication skills', 'Strengthening emotional connections', 'Learning conflict resolution', 'Practicing vulnerability and trust', 'Enhancing intimacy and closeness', 'Supporting relationship healing']
    },
    groupType: {
      label: 'What type of couples group session are you creating?',
      type: 'radio',
      options: ['Multiple couples workshop', 'Relationship support group', 'Couples retreat session', 'Family relationship healing', 'Relationship education class', 'Therapeutic group session']
    },
    experienceLevels: {
      label: 'What are the relationship experience levels in your group?',
      type: 'radio',
      options: ['All new couples', 'Mix of new and established relationships', 'All long-term partnerships', 'Couples working through challenges', 'Mixed relationship stages', 'Therapeutic/recovery focused group']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  practitionerGroupTitle: 'Personalize Your Clients\' Group Couples Session',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'What approach feels most supportive for your clients?',
      type: 'radio',
      options: ['Gentle reconnection exercises', 'Communication enhancement', 'Trust and vulnerability building', 'Emotional healing together', 'Physical intimacy renewal', 'Partnership strengthening']
    },
    primaryGoal: {
      label: 'What would be most helpful for your clients to focus on together?',
      type: 'radio',
      options: ['Building healthy communication skills', 'Strengthening emotional connections', 'Learning conflict resolution', 'Practicing vulnerability and trust', 'Enhancing intimacy and closeness', 'Supporting relationship healing']
    },
    groupType: {
      label: 'What type of couples group session are you creating?',
      type: 'radio',
      options: ['Multiple couples workshop', 'Relationship support group', 'Couples retreat session', 'Family relationship healing', 'Relationship education class', 'Therapeutic group session']
    },
    experienceLevels: {
      label: 'What are the relationship experience levels in your clients?',
      type: 'radio',
      options: ['All new couples', 'Mix of new and established relationships', 'All long-term partnerships', 'Couples working through challenges', 'Mixed relationship stages', 'Therapeutic/recovery focused group']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  practitionerTitle: 'Personalize Your Clients\' Couples Connection Session',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What approach feels most supportive for your clients\' relationship right now?',
      type: 'radio',
      options: ['Gentle reconnection exercises', 'Communication enhancement', 'Trust and vulnerability building', 'Emotional healing together', 'Physical intimacy renewal', 'Partnership strengthening']
    },
    primaryGoal: {
      label: 'What would your clients most like to focus on in their couples session?',
      type: 'radio',
      options: ['Deepening emotional connection', 'Improving communication patterns', 'Rebuilding trust and safety', 'Healing relationship wounds', 'Enhancing physical intimacy', 'Strengthening partnership bond']
    },
    relationshipStage: {
      label: 'What best describes your clients\' current relationship stage?',
      type: 'radio',
      options: ['New couple building connection', 'Established relationship seeking renewal', 'Working through relationship challenges', 'Recovering from relationship difficulties', 'Long-term partnership maintenance', 'Preparing for relationship transition']
    },
    communicationStyle: {
      label: 'How do your clients typically communicate with each other?',
      type: 'radio',
      options: ['Open and direct', 'Gentle and considerate', 'Need help expressing feelings', 'Sometimes defensive or guarded', 'Working on listening skills', 'Learning healthy conflict resolution']
    },
    intimacyFocus: {
      label: 'What aspect of intimacy would your clients like to strengthen?',
      type: 'radio',
      options: ['Emotional vulnerability and sharing', 'Physical touch and affection', 'Mental connection and understanding', 'Spiritual or values alignment', 'Playfulness and joy together', 'All aspects equally']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Couples Connection for Your Loved Ones',
  giftQuestions: {
    preferredStyle: {
      label: 'What approach feels most supportive for their relationship?',
      type: 'radio',
      options: ['Gentle reconnection exercises', 'Communication enhancement', 'Trust and vulnerability building', 'Emotional healing together', 'Physical intimacy renewal', 'Partnership strengthening']
    },
    primaryGoal: {
      label: 'What would they most benefit from focusing on?',
      type: 'radio',
      options: ['Deepening emotional connection', 'Improving communication patterns', 'Rebuilding trust and safety', 'Healing relationship wounds', 'Enhancing physical intimacy', 'Strengthening partnership bond']
    },
    relationshipStage: {
      label: 'What best describes their current relationship stage?',
      type: 'radio',
      options: ['New couple building connection', 'Established relationship seeking renewal', 'Working through relationship challenges', 'Recovering from relationship difficulties', 'Long-term partnership maintenance', 'Preparing for relationship transition']
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  }
};